import React from 'react';
import Item from './item';
import Group from './group';
import ItemADG3 from './adg3_item';
import GroupADG3 from './adg3_group';
import cx from 'classnames';

class GroupedItemsCollection extends React.Component {
  render() {
    return (
      <div className="body">
        <div
          className={cx(
            'grouped-items',
            this.props.hasGroupedItems ? null : 'no-groups',
          )}
        >
          {this.props.items.map(
            function(item, index) {
              if (item.group) {
                return this.props.use_adg3 ? (
                  <GroupADG3
                    group={item}
                    toggleItems={this.props.toggleItems}
                    key={index}
                    showChildren={item.showChildren}
                    showTooltipDescriptions={this.props.showTooltipDescriptions}
                  />
                ) : (
                  <Group
                    group={item}
                    toggleItems={this.props.toggleItems}
                    key={index}
                    showChildren={item.showChildren}
                    showTooltipDescriptions={this.props.showTooltipDescriptions}
                    improvedSubFlow={this.props.improvedSubFlow}
                  />
                );
              } else {
                return this.props.use_adg3 ? (
                  <ItemADG3
                    item={item}
                    toggle={this.props.toggleItems}
                    key={index}
                    showTooltipDescription={this.props.showTooltipDescriptions}
                  />
                ) : (
                  <Item
                    item={item}
                    toggle={this.props.toggleItems}
                    key={index}
                    showTooltipDescription={this.props.showTooltipDescriptions}
                  />
                );
              }
            }.bind(this),
          )}
        </div>
      </div>
    );
  }
}

export default GroupedItemsCollection;
